import React from "react";
import { Flame } from "lucide-react";
import { useStorefront } from "@/hooks/useStorefront";

export function useHotProduct(productId) {
    const { settings } = useStorefront();
    if (!settings || !productId) return null;
    const units = settings.units_today?.[productId] || 0;
    const threshold = Number(settings.daily_sales_alert_threshold || 0);
    if (!threshold) return null;
    const cutoff = Math.max(1, Math.floor(threshold * 0.5));
    return units >= cutoff ? { units, threshold } : null;
}

export function HotProductBadge({ productId, testid, className = "" }) {
    const hot = useHotProduct(productId);
    if (!hot) return null;
    return (
        <span
            data-testid={testid || "hot-product-badge"}
            className={`inline-flex items-center gap-1.5 bg-rose-600 text-white text-[10px] sm:text-xs font-bold px-3 py-1.5 rounded-full shadow-lg uppercase tracking-widest ${className}`}
        >
            <Flame className="w-3.5 h-3.5" />
            Selling fast today · {hot.units} sold
        </span>
    );
}
